"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asyncToGenerator2 = require("@babel/runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

require("core-js/modules/es.array.concat.js");

var _regenerator = require("@babel/runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

function _interopRequireDefault(obj) {
    try {
        return obj && obj.__esModule ? obj : { default: obj };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_interopRequireDefault@@../../../../src/views/index/fetch.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

/**
 * 预请求方法
 * 可通过 全局变量 __isServerRender__ 判断csr/ssr 模式，差异化处理请求逻辑
 * ssr 模式下，可通过产品入口服务统一进行预请求
 * ctx.fetch(options)
 *
 * csr 模式下，会在访问页面前进行预请求
 */
// const dataApi = 'http://10.90.28.42:8052/static/anything/'
var pageConfigApiEnvMap = {
  offline: 'http://10.78.133.4:30824/webx/project/getDataByXidForEntry',
  preline: 'http://100.69.239.221:8000/webx-mis-server/webx/project/getDataByXidForEntry',
  online: 'http://10.88.128.16:8000/webx-mis-server/webx/project/getDataByXidForEntry'
};

function getDataFromCtx(_x) {
    try {
        return _getDataFromCtx.apply(this, arguments);
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('getDataFromCtx@@../../../../src/views/index/fetch.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

function _getDataFromCtx() {
    try {
        _getDataFromCtx = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(ctx) {
            try {
                var fetch, xid, pageConfigApi, data, res;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    try {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                            case 0:
                                fetch = ctx.fetch, xid = ctx.query.xid;
                                console.log('process.env.WEBX_ENV', process.env.WEBX_ENV);
                                pageConfigApi = pageConfigApiEnvMap[process.env.WEBX_ENV];
                                console.log('pageConfigApi', pageConfigApi);
                                _context2.next = 6;
                                return fetch(''.concat(pageConfigApi, '/').concat(xid), { method: 'get' });
                            case 6:
                                data = _context2.sent;
                                _context2.next = 9;
                                return data.json();
                            case 9:
                                res = _context2.sent;
                                return _context2.abrupt('return', res.data);
                            case 11:
                            case 'end':
                                return _context2.stop();
                            }
                        }
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee2$@@../../../../src/views/index/fetch.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                }, _callee2);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee2@@../../../../src/views/index/fetch.js@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        }));
        return _getDataFromCtx.apply(this, arguments);
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_getDataFromCtx@@../../../../src/views/index/fetch.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

exports.default = /*#__PURE__*/function func_trir_1fe58603458a8a4660c3958cd8584866() {
    try {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref, ctx) {
            try {
                var store, router, _store$state, prefetched, page, data;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    try {
                        while (1) {
                            switch (_context.prev = _context.next) {
                            case 0:
                                store = _ref.store, router = _ref.router;
                                _store$state = store.state, prefetched = _store$state.prefetched, page = _store$state.page;
                                console.log('fetch inner1', __isServerRender__, prefetched, store, router, ctx);
                                data = {};
                                if (prefetched) {
                                    _context.next = 17;
                                    break;
                                }
                                if (!__isServerRender__) {
                                    _context.next = 11;
                                    break;
                                }
                                _context.next = 8;
                                return getDataFromCtx(ctx);
                            case 8:
                                _context.t0 = _context.sent;
                                _context.next = 14;
                                break;
                            case 11:
                                _context.next = 13;
                                return store.dispatch('getPageData');
                            case 13:
                                _context.t0 = _context.sent;
                            case 14:
                                data = _context.t0;
                                _context.next = 18;
                                break;
                            case 17:
                                data = page;
                            case 18:
                                if (!__isServerRender__) {
                                    _context.next = 21;
                                    break;
                                }
                                _context.next = 21;
                                return store.dispatch('setInitData', { payload: data });
                            case 21:
                                return _context.abrupt('return', data);
                            case 22:
                            case 'end':
                                return _context.stop();
                            }
                        }
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee$@@../../../../src/views/index/fetch.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                }, _callee);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee@@../../../../src/views/index/fetch.js@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        }));
        return function func_trir_bfefca93c87a4a07c878b2b19deaaa58(_x2, _x3) {
            try {
                return _ref2.apply(this, arguments);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_bfefca93c87a4a07c878b2b19deaaa58@@../../../../src/views/index/fetch.js@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_1fe58603458a8a4660c3958cd8584866@@../../../../src/views/index/fetch.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}();